import type { ReactNode } from 'react';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import MobileStickyBar from '../../components/layout/MobileStickyBar';
import HashScroll from '../../components/layout/HashScroll';

/**
 * Shared shell for every marketing page, both locales.
 *
 * The mobile action bar lives here rather than in a route table: which pages
 * get it is already decided by which pages use this layout, and /kiosk and
 * /tv are excluded simply by rendering their own shells. `hideMobileStickyBar`
 * is the one exception — /book already IS the booking flow, so a persistent
 * "Book" button there links to the page you are standing on.
 */
export default function SiteLayout({
  children,
  hideMobileStickyBar = false,
}: {
  children: ReactNode;
  hideMobileStickyBar?: boolean;
}) {
  return (
    <div className="min-h-screen bg-page flex flex-col">
      <HashScroll />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      {/* Sibling of main, not a descendant of the blurred header — see the
          containing-block note in MobileStickyBar. pb clears the footer's
          last row from under the bar on mobile. */}
      {!hideMobileStickyBar && (
        <>
          <div className="pb-20 lg:pb-0" aria-hidden />
          <MobileStickyBar />
        </>
      )}
    </div>
  );
}
